module.exports = __webpack_public_path__ + "static/media/fishdom@768.d5019955.png";